/* eslint-disable */
import { useState, useContext, useEffect } from 'react'
import styles from './index.module.scss'
import { FormButton } from '../../components/core/button'
import { GeneralInput } from '../../components/core/input'
import StepLine from '../../components/core/stepLine'
import {
  Help,
  SearchIcon,
  Plus,
  LangArrows,
  Close,
  Cancel,
  Add,
  Attention,
  Remove,
} from '../../icons'
import text from './text.json'
import { PageContext } from '../../context/PageContextProvider'
import ServicesAPI from '../../api/services'
import SelectsAPI from '../../api/selects'
import WorkAPI from '../../api/work'
import Loading from '../../components/pages/loading'

const RemoteStep2 = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [choices, setChoices] = useState([])
  const [input, setInput] = useState('')
  const [current, setCurrent] = useState(0)
  const [count, setCount] = useState(0)
  const [options, setOptions] = useState([])
  const [data, setData] = useState([])
  const [categories, setCategories] = useState([])
  const [results, setResults] = useState([])
  const [workspace, setWorkspace] = useState([])
  const [position, setPosition] = useState([])

  useEffect(() => {
    (async () => {

    const data1 = await ServicesAPI.getSubCategories()
    const data2 = await SelectsAPI.getWorkspace()
    const data3 = await SelectsAPI.getPosition()
    await setData(data1.data)
    await setWorkspace(data2.data)
    await setPosition(data3.data)
    let arr = []
    await data1.data.forEach((item) => {
      arr = [...arr, ...item.subcategory]
    })
    await setCategories(arr)
    await setLoad(true)
  
    })();
  }, [])
  useEffect(() => {
    const len1 = choices.length
    const len2 = options.length
    const len = len1 + len2
    setCount(len)
  }, [choices, options])

  const [reading1, setReading1] = useState(text.choose[language])
  const [reading2, setReading2] = useState(text.choose[language])
  const [reading3, setReading3] = useState(text.choose[language])
  const [reading4, setReading4] = useState(text.choose[language])
  const [reading5, setReading5] = useState(text.choose[language])
  const [reading6, setReading6] = useState(text.choose[language])
  const [reading7, setReading7] = useState(text.choose[language])
  const [reading8, setReading8] = useState(text.choose[language])
  const [reading9, setReading9] = useState(text.choose[language])
  const [reading10, setReading10] = useState(text.choose[language])
  const [readBool1, setreadBool1] = useState(false)
  const [readBool2, setreadBool2] = useState(false)
  const [readBool3, setreadBool3] = useState(false)
  const [readBool4, setreadBool4] = useState(false)
  const [readBool5, setreadBool5] = useState(false)
  const [readBool6, setreadBool6] = useState(false)
  const [readBool7, setreadBool7] = useState(false)
  const [readBool8, setreadBool8] = useState(false)
  const [readBool9, setreadBool9] = useState(false)
  const [readBool10, setreadBool10] = useState(false)

  const [writing1, setwriting1] = useState(text.choose[language])
  const [writing2, setwriting2] = useState(text.choose[language])
  const [writing3, setwriting3] = useState(text.choose[language])
  const [writing4, setwriting4] = useState(text.choose[language])
  const [writing5, setwriting5] = useState(text.choose[language])
  const [writing6, setwriting6] = useState(text.choose[language])
  const [writing7, setwriting7] = useState(text.choose[language])
  const [writing8, setwriting8] = useState(text.choose[language])
  const [writing9, setwriting9] = useState(text.choose[language])
  const [writing10, setwriting10] = useState(text.choose[language])
  const [writingBool1, setwritingBool1] = useState(false)
  const [writingBool2, setwritingBool2] = useState(false)
  const [writingBool3, setwritingBool3] = useState(false)
  const [writingBool4, setwritingBool4] = useState(false)
  const [writingBool5, setwritingBool5] = useState(false)
  const [writingBool6, setwritingBool6] = useState(false)
  const [writingBool7, setwritingBool7] = useState(false)
  const [writingBool8, setwritingBool8] = useState(false)
  const [writingBool9, setwritingBool9] = useState(false)
  const [writingBool10, setwritingBool10] = useState(false)

  const [boollang2, setBoollang2] = useState(false)
  const [boollang3, setBoollang3] = useState(false)
  const [boollang4, setBoollang4] = useState(false)
  const [boollang5, setBoollang5] = useState(false)
  const [boollang6, setBoollang6] = useState(false)
  const [boollang7, setBoollang7] = useState(false)
  const [boollang8, setBoollang8] = useState(false)
  const [boollang9, setBoollang9] = useState(false)
  const [boollang10, setBoollang10] = useState(false)

  const addHandle = (item) => {
    if (options.includes(item)) {
      let x = [...options]
      const index = x.indexOf(item)
      if (index > -1) {
        x.splice(index, 1)
        setOptions(x)
      }
    } else if (count < 20) {
      let x = [...options]
      x.push(item)
      setOptions(x)
    }
  }
  const optionHandle = () => {
    let choice = [...choices]
    let inp = input.trim()
    if (
      inp !== '' &&
      !options.includes(inp) &&
      !choices.includes(inp) &&
      count < 20
    ) {
      choice.push(inp)
      setChoices(choice)
      setInput('')
    }
  }
  const removeHandle = (item) => {
    let choice = [...choices]
    let index = choice.indexOf(item)
    choice.splice(index, 1)
    setChoices(choice)
  }
  const removeHandle2 = (item) => {
    let option = [...options]
    let index = option.indexOf(item)
    option.splice(index, 1)
    setOptions(option)
  }
  const addLang = () => {
    if (!boollang2) {
      setBoollang2(true)
    } else if (!boollang3) {
      setBoollang3(true)
    } else if (!boollang4) {
      setBoollang4(true)
    } else if (!boollang5) {
      setBoollang5(true)
    } else if (!boollang6) {
      setBoollang6(true)
    } else if (!boollang7) {
      setBoollang7(true)
    } else if (!boollang8) {
      setBoollang8(true)
    } else if (!boollang9) {
      setBoollang9(true)
    } else if (!boollang10) {
      setBoollang10(true)
    }
  }
  const sendAppeal = async () => {
    let data = await JSON.parse(sessionStorage.getItem('work'))
    let new_opt = options.map((item) => item[language])
    let arr = await [...choices, ...new_opt]
    data.options = await arr
    let fields = [
      {
        workplace: reading1,
        industry1: writing1,
        industry2: document.querySelector('#work2-industry1')?.value.trim(),
        note: document.querySelector('#work2-note1')?.value.trim(),
      },
      boollang2 && {
        workplace: reading2,
        industry1: writing2,
        industry2: document.querySelector('#work2-industry2')?.value.trim(),
        note: document.querySelector('#work2-note2')?.value.trim(),
      },
      boollang3 && {
        workplace: reading3,
        industry1: writing3,
        industry2: document.querySelector('#work2-industry3')?.value.trim(),
        note: document.querySelector('#work2-note3')?.value.trim(),
      },
      boollang4 && {
        workplace: reading4,
        industry1: writing4,
        industry2: document.querySelector('#work2-industry4')?.value.trim(),
        note: document.querySelector('#work2-note4')?.value.trim(),
      },
      boollang5 && {
        workplace: reading5,
        industry1: writing5,
        industry2: document.querySelector('#work2-industry5')?.value.trim(),
        note: document.querySelector('#work2-note5')?.value.trim(),
      },
      boollang6 && {
        workplace: reading6,
        industry1: writing6,
        industry2: document.querySelector('#work2-industry6')?.value.trim(),
        note: document.querySelector('#work2-note6')?.value.trim(),
      },
      boollang7 && {
        workplace: reading7,
        industry1: writing7,
        industry2: document.querySelector('#work2-industry7')?.value.trim(),
        note: document.querySelector('#work2-note7')?.value.trim(),
      },
      boollang8 && {
        workplace: reading8,
        industry1: writing8,
        industry2: document.querySelector('#work2-industry8')?.value.trim(),
        note: document.querySelector('#work2-note8')?.value.trim(),
      },
      boollang9 && {
        workplace: reading9,
        industry1: writing9,
        industry2: document.querySelector('#work2-industry9')?.value.trim(),
        note: document.querySelector('#work2-note9')?.value.trim(),
      },
      boollang10 && {
        workplace: reading10,
        industry1: writing10,
        industry2: document.querySelector('#work2-industry10')?.value.trim(),
        note: document.querySelector('#work2-note10')?.value.trim(),
      },
    ]
    fields = fields.filter((item) => item)
    data.fiedlsToWork = await fields
    let response = await WorkAPI.insert(data)
    if (response.status === 200) {
      sessionStorage.removeItem('work')
      window.location.href = '/success/v1'
    }
  }
  const getResults = (e) => {
    let value = e.target.value
    let arr = []
    if (value.length > 4) {
      categories.forEach((item) => {
        if (item[language].toLowerCase().includes(value.toLowerCase())) {
          arr.push(item)
        }
      })
    }
    setResults(arr)
  }
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <StepLine active={1} data={text.steps} />
      <div className={`${styles.content}`}>
        <h2>
          <Help />
          {text.question[language]}
        </h2>
        <div className={`${styles.search}`}>
          <label>
            <SearchIcon />
            <input
              onInput={(e) => getResults(e)}
              type="search"
              placeholder={text.placeholder[language]}
            />
          </label>
          {results.length > 0 && (
            <ul>
              <p>{text.result[language]}</p>
              {results.map((item, index) => (
                <li key={index}>
                  {item[language]}{' '}
                  <Add
                    onClick={() => {
                      addHandle(item)
                    }}
                  />
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className={styles.table}>
          <div>
            <p>{text.category[language]}</p>
            <ul>
              {data.map((item, i) => (
                <li
                  style={current === i ? { color: '#166FE5' } : null}
                  onClick={() => {
                    setCurrent(i)
                  }}
                  key={i}
                >
                  {item.category[language]}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p>{text.subcategory[language]}</p>
            <ul>
              {data[current].subcategory.map((item, i) => (
                <li
                  style={options.includes(item) ? { color: '#166FE5' } : null}
                  onClick={() => {
                    addHandle(item)
                  }}
                  key={i}
                >
                  {item[language]}
                </li>
              ))}
            </ul>
            <div className={styles.line} />
            <span>{text.label[language]}</span>
            <div className={styles.add}>
              <GeneralInput
                value={input}
                onInput={(e) => setInput(e.target.value)}
                placeholder={text.enter[language]}
              />
              <button
                onClick={() => {
                  optionHandle()
                }}
              >
                <Plus />
                {text.add[language]}
              </button>
            </div>
          </div>
          <div>
            <div>
              <p>{text.options[language]}</p>
              <ul>
                {options.map((item, i) => (
                  <li key={i}>
                    {item[language]}{' '}
                    <Remove
                      onClick={() => {
                        removeHandle2(item)
                      }}
                    />
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p>{text.special[language]}</p>
              <ul>
                <div>
                  {choices.map((item, i) => (
                    <li key={i}>
                      {item}{' '}
                      <Close
                        button
                        onClick={() => {
                          removeHandle(item)
                        }}
                      />
                    </li>
                  ))}
                </div>
              </ul>
              <span>
                {count}/20 <Attention />
              </span>
            </div>
          </div>
        </div>
        <h2>
          <Help />
          {text.help[language]}
        </h2>
        <div className={styles.language}>
          <div className={styles.lang}>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setreadBool1(false)
                }, 250)
              }
            >
              <p>{text.workspace[language]}</p>
              <span tabIndex="1" onClick={() => setreadBool1(true)}>
                {reading1} <LangArrows />
              </span>
              <ul
                style={readBool1 ? { display: 'block' } : { display: 'none' }}
              >
                {workspace.map((e) => (
                  <li
                    onClick={() => {
                      setReading1(e[language])
                    }}
                  >
                    {e[language]}
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setwritingBool1(false)
                }, 250)
              }
            >
              <p>{text.position[language]}</p>
              <span tabIndex="1" onClick={() => setwritingBool1(true)}>
                {writing1} <LangArrows />
              </span>
              <ul
                style={
                  writingBool1 ? { display: 'block' } : { display: 'none' }
                }
              >
                {position.map((e) => (
                  <li
                    onClick={() => {
                      setwriting1(e[language])
                    }}
                  >
                    {e[language]}
                  </li>
                ))}
              </ul>
            </div>
            <GeneralInput
              label={text.industry[language]}
              placeholder={text.enter[language]}
              id="work2-industry1"
            />
            <GeneralInput
              require={true}
              label={text.note[language]}
              placeholder={text.enter[language]}
              id="work2-note1"
            />
          </div>
          {boollang2 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool2(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool2(true)}>
                  {reading2} <LangArrows />
                </span>
                <ul
                  style={readBool2 ? { display: 'block' } : { display: 'none' }}
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading2(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool2(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool2(true)}>
                  {writing2} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool2 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting2(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry2"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                placeholder={text.enter[language]}
                id="work2-note2"
              />
              <Cancel onClick={() => setBoollang2(false)} />{' '}
            </div>
          ) : null}
          {boollang3 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool3(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool3(true)}>
                  {reading3} <LangArrows />
                </span>
                <ul
                  style={readBool3 ? { display: 'block' } : { display: 'none' }}
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading3(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool3(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool3(true)}>
                  {writing3} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool3 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting3(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry3"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                placeholder={text.enter[language]}
                id="work2-note3"
              />
              <Cancel onClick={() => setBoollang3(false)} />
            </div>
          ) : null}
          {boollang4 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool4(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool4(true)}>
                  {reading4} <LangArrows />
                </span>
                <ul
                  style={readBool4 ? { display: 'block' } : { display: 'none' }}
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading4(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool4(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool4(true)}>
                  {writing4} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool4 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting4(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry4"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                id="work2-note4"
                placeholder={text.enter[language]}
              />
              <Cancel onClick={() => setBoollang4(false)} />
            </div>
          ) : null}
          {boollang5 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool5(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool5(true)}>
                  {reading5} <LangArrows />
                </span>
                <ul
                  style={readBool5 ? { display: 'block' } : { display: 'none' }}
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading5(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool5(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool5(true)}>
                  {writing5} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool5 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting5(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry5"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                placeholder={text.enter[language]}
                id="work2-note5"
              />
              <Cancel onClick={() => setBoollang5(false)} />
            </div>
          ) : null}
          {boollang6 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool6(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool6(true)}>
                  {reading6} <LangArrows />
                </span>
                <ul
                  style={readBool6 ? { display: 'block' } : { display: 'none' }}
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading6(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool6(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool6(true)}>
                  {writing6} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool6 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting6(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry6"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                placeholder={text.enter[language]}
                id="work2-note6"
              />
              <Cancel onClick={() => setBoollang6(false)} />{' '}
            </div>
          ) : null}
          {boollang7 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool7(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool7(true)}>
                  {reading7} <LangArrows />
                </span>
                <ul
                  style={readBool7 ? { display: 'block' } : { display: 'none' }}
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading7(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool7(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool7(true)}>
                  {writing7} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool7 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting7(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry7"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                placeholder={text.enter[language]}
                id="work2-note7"
              />
              <Cancel onClick={() => setBoollang7(false)} />{' '}
            </div>
          ) : null}
          {boollang8 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool8(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool8(true)}>
                  {reading8} <LangArrows />
                </span>
                <ul
                  style={readBool8 ? { display: 'block' } : { display: 'none' }}
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading8(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool8(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool8(true)}>
                  {writing8} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool8 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting8(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry8"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                placeholder={text.enter[language]}
                id="work2-note8"
              />
              <Cancel onClick={() => setBoollang8(false)} />
            </div>
          ) : null}
          {boollang9 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool9(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool9(true)}>
                  {reading9} <LangArrows />
                </span>
                <ul
                  style={readBool9 ? { display: 'block' } : { display: 'none' }}
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading9(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool9(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool9(true)}>
                  {writing9} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool9 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting9(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry9"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                placeholder={text.enter[language]}
                id="work2-note9"
              />
              <Cancel onClick={() => setBoollang9(false)} />{' '}
            </div>
          ) : null}
          {boollang10 ? (
            <div className={styles.lang}>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setreadBool10(false)
                  }, 250)
                }
              >
                <p>{text.workspace[language]}</p>
                <span tabIndex="1" onClick={() => setreadBool10(true)}>
                  {reading10} <LangArrows />
                </span>
                <ul
                  style={
                    readBool10 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {workspace.map((e) => (
                    <li
                      onClick={() => {
                        setReading10(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={styles.select}
                onBlur={() =>
                  setTimeout(function () {
                    setwritingBool10(false)
                  }, 250)
                }
              >
                <p>{text.position[language]}</p>
                <span tabIndex="1" onClick={() => setwritingBool10(true)}>
                  {writing10} <LangArrows />
                </span>
                <ul
                  style={
                    writingBool10 ? { display: 'block' } : { display: 'none' }
                  }
                >
                  {position.map((e) => (
                    <li
                      onClick={() => {
                        setwriting10(e[language])
                      }}
                    >
                      {e[language]}
                    </li>
                  ))}
                </ul>
              </div>
              <GeneralInput
                label={text.industry[language]}
                placeholder={text.enter[language]}
                id="work2-industry10"
              />
              <GeneralInput
                require={true}
                label={text.note[language]}
                placeholder={text.enter[language]}
                id="work2-note10"
              />
              <Cancel onClick={() => setBoollang10(false)} />{' '}
            </div>
          ) : null}
        </div>
        {!boollang10 && (
          <button
            onClick={() => {
              addLang()
            }}
            className={styles.button}
          >
            <Plus />
            {text.addNew[language]}
          </button>
        )}
        <FormButton
          onClick={() => {
            sendAppeal()
          }}
        >
          {text.button[language]}
        </FormButton>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default RemoteStep2
